import React, { useContext} from "react";
// import React, { useContext, useEffect } from "react";
import { Avatar, Dropdown, Navbar } from "flowbite-react";
import NavItem from "./NavItem";
import {  CiUser } from "react-icons/ci";
import { rootContexts } from "../../contexts/rootContexts";
import Auth from "../auth/Auth";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo.png";
// import Cookies from "js-cookie";
// import { useLanguage } from '../../ChangeLanguage/LanguageContext';
export default function HeaderNav() {
  const { setAsLogin } = useContext(rootContexts);
  const { asLoginSuccess, setAsLoginSuccess } = useContext(rootContexts);
  // const [languagechange, setLanguagechange] = useState("ar");
  // const { language, changeLanguage } = useLanguage()

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
    setAsLoginSuccess(false);
  };

  // const changeLanguage = () => {
  //   setLanguagechange("en");
  //   if (window.google && window.google.translate) {
  //     const dropdown = document.querySelector(".goog-te-combo");
  //     if (dropdown) {
  //       dropdown.value = "ar";
  //       dropdown.dispatchEvent(new Event("change"));
  //     }
  //   }
  //   console.log(languagechange);
  // };
  // const changeLanguage2 = () => {
  //   setLanguagechange("ar");
  //   if (window.google && window.google.translate) {
  //     const dropdown = document.querySelector(".goog-te-combo");
  //     if (dropdown) {
  //       dropdown.value = "en";
  //       dropdown.dispatchEvent(new Event("change"));
  //     }
  //   }
  //   console.log(languagechange);
  // };

  //  const googleTranslateElementInit = () => {
  //   new window.google.translate.TranslateElement(
  //     {
  //       pageLanguage: "en",
  //       autoDisplay: false
  //     },
  //     "google_translate_element"
  //   );
  // };
  // useEffect(() => {
  //   var addScript = document.createElement("script");
  //   addScript.setAttribute(
  //     "src",
  //     "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
  //   );
  //   document.body.appendChild(addScript);
  //   window.googleTranslateElementInit = googleTranslateElementInit;
  // }, []);
  return (
    <>
      <Navbar fluid className=" bg-transparent py-4 text-center m-auto">
        <Navbar.Brand>
          <div >
            <img src={logo} className="w-[180px]" alt="logo" />
          </div>
         
        </Navbar.Brand>
        <div className="flex md:order-2 items-center gap-x-5 md:gap-x-16">
         <div id="google_translate_element" className="mt-1"></div>

          {/* <button
            // onClick={() => Cookies.set('googtrans','/auto/ar')}
            className="text-white text-xl flex  items-center gap-x-2 notranslate"
          >
            عربي <CiGlobe className="mt-2" />
          </button> */}

        

          {asLoginSuccess ? (
            <Dropdown
              arrowIcon={false}
              inline
              label={
                <Avatar
                  alt="User settings"
                  img="https://www.mgahinganationalpark.com/wp-content/uploads/2016/08/dummy-prod-1.jpg"
                  rounded
                />
              }
              className="w-40 z-50"
            >
              <Dropdown.Item>
                <Link to="/profile">Profile</Link>
              </Dropdown.Item>

              <Dropdown.Divider />
              <Dropdown.Item onClick={() => handleLogout()}>
                Sign out
              </Dropdown.Item>
            </Dropdown>
          ) : (
            <button
              onClick={() => setAsLogin(true)}
              className="text-3xl mt-2 text-white/85"
            >
              <CiUser />
            </button>
          )}
          <Navbar.Toggle className="text-white mt-3 md:mt-0" />
        </div>
        <Navbar.Collapse className="text-white text-center ">
          <NavItem to="overview" label="Overview" />
          <NavItem to="contribute" label="Contribute" />
          <NavItem to="faq" label="FAQs" />
          <NavItem to="contactus" label="Contact Us" />
        </Navbar.Collapse>
      </Navbar>
      <Auth />
    </>
  );
}
